<template>
<div class="electricity-price">
  
  <modal name="price-increase-modal"
         transition="nice-modal-fade"
         :min-width="200"
         :delay="100"
         :scrollable="true"
         :adaptive="true"
         :resizable="true"
         >
    <i class="fas fa-question-circle help-icon"></i>
    <span v-html="helper_for_price_increase"></span>    
  </modal>
  
  <div class="grid-x grid-margin-x">
    
    <div class="small-12 medium-5 large-5 cell">
      
      <label>
        <div class="form-label">Prix actuel de l'électricité hors abonnement&nbsp;:</div>
        <div class="input-group">
          <input v-model.number="current_price" type="number" @change="validateForm">
          <span class="input-group-label">
            c€ TTC/kWh
          </span>
        </div>
        <span class="help-text field-error" v-if="error_in_current_price">Le format attendu est un nombre positif.</span>
      </label>
      
      <label>
        <div class="form-label">
          Augmentation du prix de l'électricité pendant 5 ans&nbsp;:
          <button aria-label="Aide" class="modal-helper" @click="showModalPriceIncrease"><i class="fas fa-question-circle"></i></button>
        </div>
        <div class="input-group">
          <input v-model.number="price_inflation_percent_for_5_years" type="number" @change="validateForm">
          <span class="input-group-label">
            %
          </span>
        </div>
        <span class="help-text field-error" v-if="error_in_price_inflation_percent_for_5_years">Le format attendu est un nombre positif.</span>
      </label>
      
      <label>
        <div class="form-label">Augmentation du prix de l'électricité après 5 ans&nbsp;:</div>
        <div class="input-group">
          <input v-model.number="price_inflation_percent_after_5_years" type="number" @change="validateForm">
          <span class="input-group-label">
            %
          </span>
        </div>
        <span class="help-text field-error" v-if="error_in_price_inflation_percent_after_5_years">Le format attendu est un nombre positif.</span>
      </label>
      
    </div>
    
    <div class="small-12 medium-7 large-7 cell">
        <span v-html="comment"></span>
      </div>

    </div>

  </div>
</template>


<script>

import Vue from 'vue';
import { mapFields } from 'vuex-map-fields'
import { mapActions, mapMutations, mapState } from 'vuex'
import apiClient from '@/api';


export default {
    name: 'GetElectricityPrice',
    data () {
        return {
            name: "",
            comment: "",
            helper_for_price_increase: "",
        }
    },
    computed: {
            ...mapMutations(
                [
                    'setFormElectricityPriceOk',
                ],
            ),
            ...mapFields(
                [
                    'current_price',
                    'price_inflation_percent_for_5_years',
                    'price_inflation_percent_after_5_years',
                ]
            ),
        error_in_current_price: function() {
            let ok = (this.validatePositiveFloat(this.current_price));
            return !ok;
        },
        error_in_price_inflation_percent_for_5_years: function() {
            let ok = (this.validatePositiveFloat(this.price_inflation_percent_for_5_years));
            return !ok;
        },
        error_in_price_inflation_percent_after_5_years: function() {
            let ok = (this.validatePositiveFloat(this.price_inflation_percent_after_5_years));
            return !ok;
        },
    },
    mounted: function() {
        apiClient.genericGet('/eval-rentability/current-electricity-price-hypothesis/0/')
            .then(
            response => {
                console.log('Got Electricity Price Hypothesis', response);

                this.current_price = response.current_price;
                this.price_inflation_percent_after_5_years = response.price_inflation_percent_after_5_years;
                this.price_inflation_percent_for_5_years = response.price_inflation_percent_for_5_years;
                this.comment = response.comment;
                this.helper_for_price_increase = response.helper_for_price_increase;

            }
        );
    },
    methods: {
        validateForm: function() {
            let valid = !(
                this.error_in_current_price
                    || this.error_in_price_inflation_percent_for_5_years
                    || this.error_in_price_inflation_percent_after_5_years
            );
            this.$store.commit('setFormElectricityPriceOk', valid);
            return valid;
        },
        validateInteger: function(value) {
            let int_regex = new RegExp('^([0-9]+)$');
            let result = int_regex.test(value);
            return result;
        },
        validateFloat: function(value) {
            let float_regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
            let result = float_regex.test(value);
            return result;
        },
        validatePositiveFloat: function(value) {
            let float_regex = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$');
            let result = float_regex.test(value) && value>0;
            return result;
        },
        showModalPriceIncrease: function() {
            this.$modal.show('price-increase-modal')
        },
    },    
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/electricity_price.vue